<template>
    <div class="CustomScroll">
        <slot></slot>
    </div>
</template>

<script>

import Store from '@/stores/store.js'
import Bus from '@/bus/BusEvent.js'
import NormalizeWheel from '@/utils/normalizeWheel.js';
import { PointerdownSupport, PointermoveSupport} from '@/utils/support.js';
import Raf from '@/utils/raf.js'

export default {
    name: 'CustomScroll',
    props: {
        multiplyWheel: {
          type: Number,
          default: 1
        },
        preventScroll: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            isAtEnd: false,
            isAtStart: true,

            scrollX: 0,
            scrollY: 0,

            x: 0,
            y: 0,
            lastX: null,
            lastY: null,

            isScroll: false,
            isScrollEnd: false,
            hasScroll: false,

            raf: null,
            isDesktop: Store.isDesktop
        }
    },


    mounted(){
        if( this.isDesktop ){
            this.$content = this.$el.querySelector('.CustomScroll-content');
    
            Bus.$on('resize', this.resize)
            Raf.add(this.update)
    
            if (Store.isTouch) {
                this.$el.addEventListener( PointerdownSupport(), this.onTouchStart, false);
                this.$el.addEventListener( PointermoveSupport(), this.onTouchMove, false);
            } else {
                this.$el.addEventListener('wheel', this.onWheel, {passive: false});
            }
    
            //In case image aren't load, listen for their laod event in order to recalculate the scroll.
            [...this.$el.querySelectorAll('img')].forEach(element => {
                element.addEventListener('load',  ()=>{
                    this.resize();
                })
            });
    
            this.resize();
        }
    },

    beforeDestroy() {
        if( this.isDesktop ){
            Bus.$off('resize', this.resize)
    
            Raf.remove(this.update);
            
            this.$el.removeEventListener( PointerdownSupport(), this.onTouchStart, false);
            this.$el.removeEventListener( PointermoveSupport(), this.onTouchMove, false);
            this.$el.removeEventListener('wheel', this.onWheel);
        }
    },

    methods:{

        resize(){
            this.contentSize = {
                x: this.$content.offsetWidth,
                y: this.$content.offsetHeight,
            };

            this.containerSize = {
                x: this.$el.offsetWidth,
                y: this.$el.offsetHeight,
            };

            this.toggleClass();
        },

        onWheel(event) {
            if (this.preventScroll) {
                event.preventDefault();
                event.stopPropagation();
            } else if (this.scrollY > 0 &&  this.scrollY < this.contentSize.y - this.containerSize.y) {
                event.preventDefault();
                event.stopPropagation();
            }

            this.wheelVal = NormalizeWheel(event, this.pixelStep, this.lineHeight, this.pageHeight);

            // Scroll X
            // -----

            this.scrollX += this.wheelVal.pixelX * this.multiplyWheel;

            if (this.scrollX > this.contentSize.x - this.containerSize.x) {
                this.scrollX = this.contentSize.x - this.containerSize.x;
            }
            if (this.scrollX < 0) {
                this.scrollX = 0;
            }

            // Scroll Y
            // -----
            this.scrollY += this.wheelVal.pixelY * this.multiplyWheel;

            if (this.scrollY > this.contentSize.y - this.containerSize.y) {
                this.scrollY = this.contentSize.y - this.containerSize.y;
            }
            if (this.scrollY < 0) {
                this.scrollY = 0;
            }

            this.toggleClass();
        },

        onTouchStart(event) {
            this.pointerEvent = this.isTouch && event.type != 'mousemove' ? (event.touches[0] || event.changedTouches[0]) : event;
            this.oldDeltaY = this.scrollY;
            this.startDeltaY = this.pointerEvent.pageY;

            this.oldDeltaX = this.scrollX;
            this.startDeltaX = this.pointerEvent.pageX;
        },

        onTouchMove(event) {
            this.pointerEvent = this.isTouch && event.type != 'mousemove' ? (event.touches[0] || event.changedTouches[0]) : event;

            // Scroll Y
            // -----
            this.scrollY = this.oldDeltaY - (this.pointerEvent.pageY - this.startDeltaY) * 2;
            
            if (this.scrollY > this.contentSize.y - this.containerSize.y) {
                this.scrollY = this.contentSize.y - this.containerSize.y;
            }
            if (this.scrollY < 0) {
                this.scrollY = 0;
            }

            if (this.scrollY > 0 &&  this.scrollY < this.contentSize.y - this.containerSize.y) {
                // event.preventDefault();
                // event.stopPropagation();
            }

            // Scroll X
            // -----
            this.scrollX = this.oldDeltaX - (this.pointerEvent.pageX - this.startDeltaX) * 2;

            if (this.scrollX > this.contentSize.x - this.containerSize.x) {
                this.scrollX = this.contentSize.x - this.containerSize.x;
            }
            if (this.scrollX < 0) {
                this.scrollX = 0;
            }

            if (this.scrollX > 0 &&  this.scrollX < this.contentSize.x - this.containerSize.x) {
                // event.preventDefault();
                // event.stopPropagation();
            }

            this.toggleClass();
        },

        toggleClass() {
            this.isScroll = (this.scrollY > 1) || (this.scrollX > 1);

            if ( (this.contentSize.y > this.containerSize.y) && (this.contentSize.x > this.containerSize.x) ){
                console.warn(this.$el, "Custom scroll with two axis scrollable !")
            }
            
            this.isScrollEnd = (this.contentSize.y !== this.containerSize.y) && (this.scrollY >= (this.contentSize.y - this.containerSize.y)) ||
                                (this.contentSize.x !== this.containerSize.x) && (this.scrollX >= (this.contentSize.x - this.containerSize.x))

            if (this.isScroll) {
                this.$el.classList.add('is-scroll');
                if( !this.hasScroll ){
                    this.$el.classList.add('has-scroll');
                    this.hasScroll = true;
                }
            } else {
                this.$el.classList.remove('is-scroll');
            }

            if (this.isScrollEnd) {
                this.$el.classList.add('is-scroll-end');
            } else {
                this.$el.classList.remove('is-scroll-end');
            }
        },

        goToScroll(x, y) {
            this.scrollX = x;
            this.scrollY = y;

            // Scroll X
            // -----
            if (this.scrollX > this.contentSize.x - this.containerSize.x) {
                this.scrollX = this.contentSize.x - this.containerSize.x;
            }
            if (this.scrollX < 0) {
                this.scrollX = 0;
            }

            // Scroll Y
            // -----
            if (this.scrollY > this.contentSize.y - this.containerSize.y) {
                this.scrollY = this.contentSize.y - this.containerSize.y;
            }
            if (this.scrollY < 0) {
                this.scrollY = 0;
            }

            this.toggleClass();
        },

        update() {
            if ( Math.abs(this.scrollX - this.x) > 0.1 ){
                this.x += (this.scrollX - this.x) * 0.1;
            }
            if ( Math.abs(this.scrollY - this.y) > 0.1) {
                this.y += (this.scrollY - this.y) * 0.1;
            }

            Store.state.scrollRatio = Math.round(this.y) / (this.contentSize.y - this.containerSize.y)
            

            if( (this.contentSize.y - this.containerSize.y) - this.y < 2 ){
                if( !this.isAtEnd ) this.isAtEnd = true;
            }else{
                if( this.isAtEnd ) this.isAtEnd = false;
            }

            this.isAtStart = this.y <= 2;

            if (this.lastX !== this.x || this.lastY !== this.y){
                this.$content.style.transform = `translate(-${this.x}px, -${this.y}px) translateZ(0)`;

                this.lastX = this.x;
                this.lastY = this.y;
            }
        }
    },
    watch: {
        isAtEnd: function (val) {
            this.$parent.$emit('onScrollAtEnd', val);
        },

        isAtStart: function (val) {
            this.$parent.$emit('onScrollAtStart', val);
        }
    }
}
</script>


<style scoped lang="scss">
    .CustomScroll{
        overflow: hidden;
        @include respond-to(md){
            overflow: auto;
        }
    }
</style>
